import * as propertyTypes from "../../property_types.js"
import { DataIsTemplateStringProperty, RightDrawerContainer, DataMenu, DataGridOptions } from "./common_app_metadata.js";

export class AppAddress extends propertyTypes.Serializable {
    private additionalMetadata = new propertyTypes.ObjectPropertyExt("additional", "Additional")
        .addStateImplementation("default", Additional);
    public additional: Additional;

    private metadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.additionalMetadata.RenderInline = true;
        this.metadataAll = [this.additionalMetadata];
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.metadataAll;
    }

}

class Additional extends propertyTypes.Serializable {

    private objectsMetadata = new propertyTypes.ObjectListPropertyExt("objects", "Additional objects", "name")
        .addStateImplementation("browserTitle", DataIsTemplateStringProperty)
        .addStateImplementation("pageTitle", DataIsTemplateStringProperty)
        .addStateImplementation("allocationsGridOptions", DataGridOptions)
        .addStateImplementation("contactsGridOptions", DataGridOptions)
        .addStateImplementation("openingHoursGridOptions", DataGridOptions)
        .addStateImplementation("openingHoursSchema", DataOpeningHoursSchema)
        .addStateImplementation("menuDataSource", DataMenu)
        .addStateImplementation("translations", DataTranslations)
        //.addStateImplementation("ticketStructureTemplate", DataIsTemplateStringProperty)
        .addStateImplementation("rightDrawerContainer", RightDrawerContainer);
    ;
    public objects: string;

    private additionalMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.objectsMetadata.IsReadOnly = true;
        this.additionalMetadata = [this.objectsMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.additionalMetadata;
    }
}

class DataTranslations extends propertyTypes.Serializable {
    private nameMetadata = new propertyTypes.TextProperty("name", "Name");
    public name: string;

    private dataMetadata = new propertyTypes.ObjectPropertyExt("data", "Data")
        .addStateImplementation("default", MachineAppTranslations);
    public data: MachineAppTranslations;

    private additionalMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.nameMetadata.IsReadOnly = true;
        this.additionalMetadata = [this.nameMetadata, this.dataMetadata];
        //this.dataMetadata.RenderInline = true;
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.additionalMetadata;
    }
}

class MachineAppTranslations extends propertyTypes.Serializable {
    private Standard_Msg_LoeschenMetadata = new propertyTypes.TranslatableTextProperty("Standard.Msg.Loeschen", "Standard.Msg.Loeschen");
    private Maschine_BereitsZugewiesen = new propertyTypes.TranslatableTextProperty("Maschine.BereitsZugewiesen", "Maschine.BereitsZugewiesen");
    private WebSMS_PartsList_SwapPart = new propertyTypes.TranslatableTextProperty("WebSMS.PartsList.SwapPart", "WebSMS.PartsList.SwapPart");
    private WebSMS_PartsList_ArtNo = new propertyTypes.TranslatableTextProperty("WebSMS.PartsList.ArtNo", "WebSMS.PartsList.ArtNo");
    private WebSMS_PartsList_ArticleNo = new propertyTypes.TranslatableTextProperty("WebSMS.PartsList.ArticleNo", "WebSMS.PartsList.ArticleNo");

    private WebSMS_PartsList_ArtName = new propertyTypes.TranslatableTextProperty("WebSMS.PartsList.ArtName", "WebSMS.PartsList.ArtName");
    private WebSMS_PartsList_ArtBatchNo = new propertyTypes.TranslatableTextProperty("WebSMS.PartsList.ArtBatchNo", "WebSMS.PartsList.ArtBatchNo");
    private WebSMS_PartsList_ArtSerialNo = new propertyTypes.TranslatableTextProperty("WebSMS.PartsList.ArtSerialNo", "WebSMS.PartsList.ArtSerialNo");
    private WebSMS_PartsList_ArtInWhichStore = new propertyTypes.TranslatableTextProperty("WebSMS.PartsList.ArtInWhichStore", "WebSMS.PartsList.ArtInWhichStore");
    private WebSMS_PartsList_ArtAmount = new propertyTypes.TranslatableTextProperty("WebSMS.PartsList.ArtAmount", "WebSMS.PartsList.ArtAmount");

    private Standard_Neu = new propertyTypes.TranslatableTextProperty("Standard.Neu", "Standard.Neu");
    private Standard_Editieren = new propertyTypes.TranslatableTextProperty("Standard.Editieren", "Standard.Editieren");
    private Standard_Loeschen = new propertyTypes.TranslatableTextProperty("Standard.Loeschen", "Standard.Loeschen");
    private Maschine_Maschinensuche = new propertyTypes.TranslatableTextProperty("Maschine.Maschinensuche", "Maschine.Maschinensuche");
    private WebSMS_Title_MachineEditing = new propertyTypes.TranslatableTextProperty("WebSMS.Title.MachineEditing", "WebSMS.Title.MachineEditing");
    private WebSMS_UserSettings_Skills_MachineSkills = new propertyTypes.TranslatableTextProperty("WebSMS.UserSettings.Skills.MachineSkills", "WebSMS.UserSettings.Skills.MachineSkills");
    private WebSMS_UserSettings_Skills_MachineTypeSkills = new propertyTypes.TranslatableTextProperty("WebSMS.UserSettings.Skills.MachineTypeSkills", "WebSMS.UserSettings.Skills.MachineTypeSkills");
    private WebSMS_Machine_MachineType = new propertyTypes.TranslatableTextProperty("WebSMS.Machine.MachineType", "WebSMS.Machine.MachineType");

    private Adresse_BereitsZugewiesen = new propertyTypes.TranslatableTextProperty("Adresse.BereitsZugewiesen", "Adresse.BereitsZugewiesen");
    private Standard_Msg_SpeichernFehler = new propertyTypes.TranslatableTextProperty("Standard.Msg.SpeichernFehler", "Standard.Msg.SpeichernFehler");
    private Standard_Msg_SpeichernErfolgreich = new propertyTypes.TranslatableTextProperty("Standard.Msg.SpeichernErfolgreich", "Standard.Msg.SpeichernErfolgreich");
    private Standard_Kopieren = new propertyTypes.TranslatableTextProperty("Standard.Kopieren", "Standard.Kopieren");
    private WebSMS_Title_ContactEditing = new propertyTypes.TranslatableTextProperty("WebSMS.Title.ContactEditing", "WebSMS.Title.ContactEditing");
    private Adresse_AdresseSuchen = new propertyTypes.TranslatableTextProperty("Adresse.AdresseSuchen", "Adresse.AdresseSuchen");
    private WebSMS_AddressOpeningHours_OpeningHours = new propertyTypes.TranslatableTextProperty("WebSMS.AddressOpeningHours.OpeningHours", "WebSMS.AddressOpeningHours.OpeningHours");
    private WebSMS_Title_AddressEditing = new propertyTypes.TranslatableTextProperty("WebSMS.Title.AddressEditing", "WebSMS.Title.AddressEditing");

    private allTranslationsMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.allTranslationsMetadata = [this.Standard_Msg_LoeschenMetadata, this.Maschine_BereitsZugewiesen, this.WebSMS_PartsList_SwapPart,
        this.WebSMS_PartsList_ArtNo, this.WebSMS_PartsList_ArticleNo, this.WebSMS_PartsList_ArtName, this.WebSMS_PartsList_ArtName,
        this.WebSMS_PartsList_ArtBatchNo, this.WebSMS_PartsList_ArtSerialNo, this.WebSMS_PartsList_ArtInWhichStore, this.WebSMS_PartsList_ArtAmount,
        this.Standard_Neu, this.Standard_Editieren, this.Standard_Loeschen, this.Maschine_Maschinensuche, this.WebSMS_Title_MachineEditing,
        this.WebSMS_UserSettings_Skills_MachineSkills, this.WebSMS_UserSettings_Skills_MachineTypeSkills, this.WebSMS_Machine_MachineType,
        this.Adresse_BereitsZugewiesen, this.Standard_Msg_SpeichernFehler, this.Standard_Msg_SpeichernErfolgreich, this.Standard_Kopieren,
        this.WebSMS_Title_ContactEditing, this.Adresse_AdresseSuchen, this.WebSMS_AddressOpeningHours_OpeningHours, this.WebSMS_Title_AddressEditing
        ];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.allTranslationsMetadata;
    }
}

class DataOpeningHoursSchema extends propertyTypes.Serializable {
    private dataMetadata = new propertyTypes.NotEditableProperty("data", "Data");
    public data: string;

    private additionalMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.additionalMetadata = [this.dataMetadata];
        //this.dataMetadata.RenderInline = true;
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.additionalMetadata;
    }
}